import { useEffect, forwardRef } from 'react';

const FormatedPrice = forwardRef((props) => {
	
	useEffect(() => {

	}, [])

	const formatter = new Intl.NumberFormat('uk-UA', {
		style: 'currency',
		currency: 'UAH',
		currencyDisplay: "narrowSymbol",
		trailingZeroDisplay: 'stripIfInteger'
	});

	return (
		<span>
			{ formatter.format(props.price) }
		</span>
	);
});

export default FormatedPrice;